import React from "react";
import { Text } from "@chakra-ui/react";

export interface ValueColorRule {
  value?: string | null;
  backgroundColor: string;
  color: string;
}

interface StatusBadgeProps {
  value: string;
  rules: ValueColorRule[];
}

function getValueStyles(
  value: string,
  rules: ValueColorRule[]
): { backgroundColor: string; color: string } | undefined {
  if (rules.length === 0) return undefined;
  const str = value != null ? String(value).trim() : "";
  if (str === "" || str === "-") return undefined;

  for (let i = 0; i < rules.length - 1; i++) {
    const rule = rules[i];
    if (
      rule.value != null &&
      str.toLowerCase() === String(rule.value).toLowerCase()
    ) {
      return {
        backgroundColor: rule.backgroundColor,
        color: rule.color,
      };
    }
  }
  const defaultRule = rules[rules.length - 1];
  return {
    backgroundColor: defaultRule.backgroundColor,
    color: defaultRule.color,
  };
}

export const StatusBadge = ({ value, rules }: StatusBadgeProps) => {
  const styles = getValueStyles(value, rules);
  return (
    <Text
      as="span"
      px={2}
      py={0.5}
      borderRadius="md"
      fontSize="xs"
      fontWeight="medium"
      display="inline-block"
      {...(styles ?? {})}
    >
      {value}
    </Text>
  );
};

export const BOOLEAN_TRUE_RULES: ValueColorRule[] = [
  { value: "true", backgroundColor: "green.500", color: "white" },
  { value: "yes", backgroundColor: "green.500", color: "white" },
  { backgroundColor: "red.500", color: "white" },
];

export const BOOLEAN_FALSE_RULES: ValueColorRule[] = [
  { value: "false", backgroundColor: "green.500", color: "white" },
  { value: "no", backgroundColor: "green.500", color: "white" },
  { backgroundColor: "red.500", color: "white" },
];
